import { render, staticRenderFns } from "./supplierTrue.vue?vue&type=template&id=5c6fb8e0"
import script from "./supplierTrue.vue?vue&type=script&lang=js"
export * from "./supplierTrue.vue?vue&type=script&lang=js"
import style0 from "./supplierTrue.vue?vue&type=style&index=0&id=5c6fb8e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports